import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import './Clip.css';

//Das ist NICHT der Single-View-Clip, sondern nur ein Eintrag in der Clipsarea-Liste
const Clip = observer(
  class Clip extends Component {
	
		chains = ["France 2","France 3","France 4","France 5","Réseau la 1ère","Outre-Mer la 1ère","france.tv distribution","france.tv","Lumni","france.tv Slash"];
		chacls = ["france_2","france_3","france_4","france_5","reseau_la_1ere","outre_mer_la_1ere","france_tv_distribution","france_tv","lumni","france_tv_slash"];
		
		getIcClass = (md) => {
			let ic = 'france_tv';
			if(this.chains.indexOf(md) > -1)
				ic = this.chacls[this.chains.indexOf(md)];
			return 'chiconcont ch_'+ic;
		}
		
		frenchDate(rd,rt) {
			if(typeof(rd) != 'string' || rd.length != 10)
					return false;
			let mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre" ];
			let today = new Date(rd);
			let year = today.getFullYear();
			let dayNumber = today.getDate();
			let month = mois[today.getMonth()];
			let weekday = today.toLocaleDateString("fr-FR", { weekday: "long" });
			let fdate =  `${dayNumber} ${month} ${year}`;
			if(typeof(rt) == 'string')
				 fdate += ' à ' + rt;
			 return fdate;
		}
			
    render() {
			let cl = this.props.cl;
			let subt = cl.getMetadata().get('txt23');
			if(typeof(subt) == 'string' && subt != '')
				subt = ' / ' + subt;
			else subt = '';
			let mt = cl.getMainthumbnail();
			if(mt != null)
				mt = mt.getUrl()+'&height=300&width=300&cache=1';
			else 
				mt = '';
			let md = cl.data.metadata.fields;
			let ic = this.getIcClass(cl.getMetadata().get('txt3'));
			let dd = this.frenchDate(md.txt6,md.txt7);
			return  (
				<Col xs={12} sm={6} md={4} lg={3} >
					<div onClick={()=>{ this.props.clipclickcb(cl.getId()) }}     className="clipcont">
						<div className="thumbcont">
							<img className="clipthumb" src={mt} />
						</div>
						<div className="metacont">
							<div className={ic} />
							<div className="metatitlecont">
								{cl.getMetadata().get('title') + subt}
							</div>
							<div className="metadatecont">
								{dd}
							</div>
						</div>
					</div>
				</Col>
			)
    }
		
  }
)


export default Flow.injectFlow(Clip);